module.exports = __webpack_public_path__ + "media/images/svg-icon/icons-d7044a6415773151e3959c6a894cbb39.svg";